var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFastForward4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.559,
    height: 19.855,
    viewBox: "0 0 14.559 19.855",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fast-forward",
    transform: "translate(0 19.855) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_57",
    "data-name": "Groupe 57",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_56",
    "data-name": "Groupe 56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_40",
    "data-name": "Trac\\xE9 40",
    d: "M.17,7.721l5.956,6.618a.662.662,0,0,0,.492.22h3.971a.661.661,0,0,0,.492-1.1L5.524,7.279l5.558-6.174A.662.662,0,0,0,10.589,0H6.618a.671.671,0,0,0-.492.218L.17,6.836A.662.662,0,0,0,.17,7.721Z",
    fill: "#707070"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_59",
    "data-name": "Groupe 59",
    transform: "translate(8.604 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_58",
    "data-name": "Groupe 58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_41",
    "data-name": "Trac\\xE9 41",
    d: "M.17,7.721l5.956,6.618a.662.662,0,0,0,.492.22h3.971a.661.661,0,0,0,.492-1.1L5.524,7.279l5.558-6.174A.662.662,0,0,0,10.589,0H6.618a.671.671,0,0,0-.492.218L.17,6.836A.662.662,0,0,0,.17,7.721Z",
    fill: "#707070"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastForward4);
export default __webpack_public_path__ + "static/media/fast-forward4.77d91b0e8afb083c3e32049d082163e1.svg";
export { ForwardRef as ReactComponent };